import {Component} from '@angular/core';
import {InfoModalComponent} from "./info_modal.component";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<p>{{message}}</p>
		</info-modal>
	`
})
export class AlertComponent extends InfoModalComponent {
	public message:string = 'Alert';
	
	ok() {
		this.close();
	}
}
